export const SET_MESSAGING = 'SET_MESSAGING';
export default { SET_MESSAGING };
